import { render, staticRenderFns } from "./checklist.vue?vue&type=template&id=3dd19b36&scoped=true&"
import script from "./checklist.vue?vue&type=script&lang=js&"
export * from "./checklist.vue?vue&type=script&lang=js&"
import style0 from "./checklist.vue?vue&type=style&index=0&id=3dd19b36&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd19b36",
  null
  
)

export default component.exports